import { DropDownButton } from "./DropDownButton";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { OptionNaming, SelectPopover } from "../../atoms";

export type FilterDropdownProps = {
  display: string;
  options?: OptionNaming[];

  onChange?: (index: number, value: any) => void;
  value?: any;

  fullWidth?: boolean;
  size?: "large" | "small";
  variant?: "text" | "contained";
  color?: "primary" | "secondary";
  colorLevel?: "light" | "main" | "dark";
};

export const FilterDropdown = ({ display, options, value, onChange = () => {}, ...others }: FilterDropdownProps) => {
  const [localDisplay, setLocalDisplay] = useState(display);

  useEffect(() => {
    setDisplay();
  }, [value, options]);
  const setDisplay = () => {
    if (typeof value === "undefined" || !options) {
      setLocalDisplay(display);
    } else {
      const index = options.findIndex((x) => x.value === value);

      if (index === -1) {
        setLocalDisplay(display);
      } else {
        setLocalDisplay(options[index].text);
      }
    }
  };

  return (
    <Box>
      <SelectPopover options={options} onChange={onChange} render={(handleClick) => <DropDownButton handleClick={handleClick} display={localDisplay} {...others} />}></SelectPopover>
    </Box>
  );
};
export default FilterDropdown;
